var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMirrorInner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450,
    height: 342
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 67.943v206.04a5.04 5.04 0 002.316 4.3A148.28 148.28 0 0154.9 339.044 4.98 4.98 0 0059.459 342h331.156a4.98 4.98 0 004.557-2.956 148.278 148.278 0 0152.537-60.813 4.944 4.944 0 002.291-4.3V67.943a4.944 4.944 0 00-2.291-4.3 148.032 148.032 0 01-52.588-60.712A5.059 5.059 0 00390.565 0H59.409A5.061 5.061 0 0054.9 2.931 148.181 148.181 0 012.316 63.72a4.973 4.973 0 00-1.693 1.813A5.108 5.108 0 000 67.943z",
    fill: "#003c3b"
  })));
}

export default __webpack_public_path__ + "b0b1643daf42da84e93bf32eb39091bc.svg";
export { SvgMirrorInner as ReactComponent };